module.exports = __webpack_public_path__ + "static/media/icon-gresb.c6c8c9d4.png";